import { render } from "./OperationsMaster.vue?vue&type=template&id=368e3994"
import script from "./OperationsMaster.vue?vue&type=script&lang=js"
export * from "./OperationsMaster.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__